import {Point} from '@app/modules/svg/model/Point';
import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {RayView2} from '@app/modules/svg/element/complex/cartesian2/RayView2';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {DrawTwoPoint} from '@app/modules/svg/service/tool/draw/element/DrawTwoPoint';

export class DrawRay2 extends DrawTwoPoint {
  protected createDrawableElement(position: Point): RayView2 {
    const element: RayView2 = new RayView2(this.drawTool.container, {overEvent: true, globalStyle: true}, {}, position, position);
    element.__fixRect__();
    return element;
  }

  public override start(call: boolean = true): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.RAY_TOOL_ON);
    }
  }
  public override stop(call: boolean = true): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.RAY_TOOL_OFF);
    }
  }

  public _new(): DrawRay2 {
    return new DrawRay2(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.RAY2;
  }
}
